<template>
  <div>
    <b-navbar variant="dark" class="lizard-navbar">
      <b-navbar-brand>
        <span @click="goToCandesic" title="Candesic.com" class="brand-wrapper">
          <!-- <img src="../assets/logo.png" width="28" alt="" v-if="isUp()" />
          <strong class="strokeme" v-if="isUp()">&nbsp;{{ appName }}</strong>
          <strong class="strokeme2" v-if="!isUp()">{{ appName }}</strong></span
        > -->
          <img
            src="../assets/candesic-2.png"
            @click="goToCandesic"
            title="Candesic.com"
            width="140"
            class="brand-logo" />
          <span class="strokeme" v-if="isUp()">{{ appName }}</span>
        </span>
      </b-navbar-brand>
      <AzureAuth
        class="lizard-navbar-azure"
        :mobileView="mobileView"
        v-if="isUp() && !hideButton" />
    </b-navbar>
  </div>
</template>

<script>
import AzureAuth from './Azure.vue'

export default {
  name: 'NavbarComponent',
  props: {
    mobileView: {
      type: Boolean,
      required: true
    },
    hideButton: {
      type: Boolean,
      default: true,
      required: true
    }
  },
  components: {
    AzureAuth
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    appName() {
      return this.Store.appName ?? 'default'
    },
    appVersion() {
      return this.Store.appVersion ?? '0.0.0'
    },
    appEnv() {
      return this.Store.appEnv ?? process?.env?.VUE_APP_ENV ?? 'production'
    },
    appMessage() {
      return this.Store.appMessage ?? ''
    },
    UserData() {
      return this.Store.userAuth
    },
    IsAuthenticated() {
      return this.UserData.authenticated
    }
  },
  data() {
    return {
      status: this?.$store?.getters?.appStatus ?? 'up',
      env: this?.$store?.getters?.appEnv ?? 'production'
    }
  },
  methods: {
    isUp() {
      return this.status === 'up'
    },
    isPrd() {
      return ['staging', 'development'].indexOf(this.env) === -1
    },
    goToCandesic() {
      window.open('https://www.candesic.com')
    }
  }
}
</script>

<style scoped>
.lizard-navbar {
  min-height: 64px !important;
  background: rgba(245, 244, 239, 0.85) !important;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(245, 244, 239, 0.5);
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.04);
  padding: 0.5rem 2rem !important;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
}

.lizard-navbar-azure {
  position: absolute;
  right: 2rem !important;
  display: flex;
  align-items: center;
}

.brand-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.brand-logo {
  cursor: pointer;
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.02));
}

.brand-logo:hover {
  transform: scale(1.03);
}

.strokeme {
  font-family: 'CANDESIC-FONT', Arial, Helvetica, sans-serif;
  text-transform: capitalize;
  margin-left: 4px !important;
  color: rgb(0, 114, 188);
  font-size: 14pt !important;
  font-weight: bold;
}

pre {
  display: inline-flex;
  margin: 0 0 0 10px;
}
</style>
